import Http, {UrlFull} from '../Http';

export const getImageUser = () =>
  Http.get(UrlFull + 'api/util/def/' + process.env.REACT_APP_ID);
